import { toast } from 'tailwind-toast';
import { languages } from '@/locales/index.js';
import Vue from 'vue';

const locale = Vue.prototype.$locale;

export const toasters = {
  triggerError: (message = null) => {
    toast()
      .danger('', message ? message : languages[locale].shared.forms.submit.error)
      .with({
        shape: 'square',
        duration: 5000,
        speed: 200,
        positionX: 'end',
        positionY: 'bottom',
        icon: 'hidden',
        color: 'bg-danger'
      })
      .show();
  },
  triggerSuccess: (message = null) => {
    toast()
      .danger('', message ? message : languages[locale].shared.forms.submit.success)
      .with({
        shape: 'square',
        duration: 5000,
        speed: 200,
        positionX: 'end',
        positionY: 'bottom',
        icon: 'hidden',
        color: 'bg-success'
      })
      .show();
  }
};
